import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./profile.css";
import { getProfile, updateProfile } from "../../service/auth_service.js";

function EmployeeProfile() {
  const [formData, setFormData] = useState({
    employeeid: "",
    employeename: "",
    mobilenumber: "",
    profileimage: null,
    email: "",
    designation: "",
    joiningdate: "",
    role: "",
    dateofbirth: "",
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "profileimage") {
      const file = files[0];

      setFormData((prev) => ({
        ...prev,
        profileimage: file,
      }));

      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => setImagePreview(reader.result);
        reader.readAsDataURL(file);
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const data = new FormData();

      data.append("employeename", formData.employeename);
      data.append("mobilenumber", formData.mobilenumber);
      data.append("dateofbirth", formData.dateofbirth);

      if (formData.profileimage) {
        data.append("profileimage", formData.profileimage);
      }

      const response = await updateProfile(data);

      if (response.status === "success") {
        toast.success("Profile updated successfully");
        getProfileData();
      } else {
        toast.error(response.message || "Update failed");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const getProfileData = async () => {
    try {
      const response = await getProfile();

      if (response.status === "success" && response.data) {
        const data = response.data;

        setFormData({
          employeeid: data.employeeid || "",
          employeename: data.employeename || "",
          mobilenumber: data.mobilenumber || "",
          profileimage: null,
          email: data.email || "",
          designation: data.designation || "",
          joiningdate: data.joiningdate || "",
          role: data.role || "",
          dateofbirth: data.dateofbirth || "",
        });

        const profileUrl = data.profile ? data.profile : null;
        setImagePreview(profileUrl);

        // Update localStorage for Header reflection
        localStorage.setItem("user_name", data.employeename || "");
        localStorage.setItem("user_profile", profileUrl || "");

        // Dispatch event for immediate Header reflection
        window.dispatchEvent(new Event("profileUpdated"));
      } else {
        toast.error(response.message || "Failed to fetch profile data");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    setPageLoading(true);
    getProfileData();
  }, []);

  return (
    <div className="profile-container">
      <h4>My Profile</h4>

      {pageLoading ? (
        <div className="loading-state">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <>
          <div className="profile-image-section">
            <div
              className="profile-preview-wrapper"
              onClick={() => document.querySelector(".profile-upload").click()}
            >
              <img
                src={
                  imagePreview ||
                  "https://cdn-icons-png.flaticon.com/128/3135/3135715.png"
                }
                alt="Profile"
                className="profile-image"
                onError={(e) => {
                  e.target.src =
                    "https://cdn-icons-png.flaticon.com/128/3135/3135715.png";
                }}
              />
              <div className="upload-overlay-icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
              </div>
            </div>

            <div className="profile-image-info">
              <h5>Profile Photo</h5>
              <p>Update your photo to reflect across the platform</p>
              <button
                type="button"
                className="change-photo-btn"
                onClick={() => document.querySelector(".profile-upload").click()}
              >
                Change Photo
              </button>
            </div>

            <input
              type="file"
              name="profileimage"
              onChange={handleChange}
              accept=".png, .jpg, .jpeg"
              style={{ display: "none" }}
              className="profile-upload"
            />
          </div>

          <div className="profile-card">
            <form className="profile-form" onSubmit={handleSubmitForm}>
              <div className="profile-form-group">
                <label>Name</label>
                <input
                  type="text"
                  name="employeename"
                  placeholder="Enter Name"
                  value={formData.employeename}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="profile-form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="mobilenumber"
                  placeholder="Enter Phone Number"
                  value={formData.mobilenumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="profile-form-group">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="dateofbirth"
                  value={formData.dateofbirth}
                  onChange={handleChange}
                />
              </div>

              <div className="profile-form-group">
                <label>Email</label>
                <input type="text" value={formData.email} disabled />
              </div>

              <div className="profile-form-group">
                <label>Designation</label>
                <input type="text" value={formData.designation} disabled />
              </div>
              <div className="profile-form-group">
                <label>Joining Date</label>
                <input type="text" value={formData.joiningdate} disabled />
              </div>
            </form>
            <div className="profile-buttons">
              <button
                type="submit"
                className="apply-btn"
                onClick={handleSubmitForm}
                disabled={loading}
              >
                {loading ? "Loading..." : "Update Profile"}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default EmployeeProfile;
